import axiosClient from '../axiosClient';

const userAPI = {
    async deposit(data) {
        const url = `/user/deposit`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },
    async getGiftAPI(data) {
        const url = `/user/get_gift`;
        const resp = await axiosClient.post(url, data);
        return resp;
    },
};

export default userAPI;
